import { render } from "./csrf.vue?vue&type=template&id=2c83530b"
import script from "./csrf.vue?vue&type=script&lang=js"
export * from "./csrf.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__